import { render, staticRenderFns } from "./addPrivacyList.vue?vue&type=template&id=7dac190b&"
import script from "./addPrivacyList.vue?vue&type=script&lang=js&"
export * from "./addPrivacyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dac190b')) {
      api.createRecord('7dac190b', component.options)
    } else {
      api.reload('7dac190b', component.options)
    }
    module.hot.accept("./addPrivacyList.vue?vue&type=template&id=7dac190b&", function () {
      api.rerender('7dac190b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addPrivacyList.vue"
export default component.exports